  <div class="question-container">
      <label>{{ label }}</label>
      <mat-form-field appearance="outline" class="half-width">
      <input 
        matInput 
        [value]="displayValue" 
        (click)="hasFile ? null : openUploadDialog()"
        readonly  
        [placeholder]="placeholder"
        [class.has-file]="hasFile" />

      @if(!hasFile)  {  
        <button class="m-r-1"
          mat-icon-button matSuffix
          type="button"
          (click)="openUploadDialog()"
          [disabled]="disabled">
          <mat-icon>upload</mat-icon>
        </button>
    }
      
      @if(hasFile){
        <button class="m-r-1"
          mat-icon-button matSuffix
          type="button"
          (click)="removeFile()"
          [disabled]="disabled">
          <mat-icon>close</mat-icon>
        </button>
      }
    

        @if (fileUploadErrorMessage) {    
            <mat-error>
                {{fileUploadErrorMessage}}
            </mat-error>
        }
      </mat-form-field>
</div>
